// Public page policy shared by edge, Next.js and client navigation.
import { buildLanguageUrl } from './localeRouting';

export const isDocumentPath = (path) => /^\/document(?:\/|$)/.test(path);
export const legalPath = (path) => ({
  '/privacy-policy': '/privacy-policy', '/chinh-sach-bao-mat': '/privacy-policy',
  '/term-of-use': '/term-of-use', '/dieu-khoan-su-dung': '/term-of-use'
})[path.replace(/\/$/, '')] || null;
export const isPricingPath = (path) => ['/service-pack', '/goi-dich-vu'].includes(path.replace(/\/$/, ''));
const englishUrl = (path) => buildLanguageUrl('en', path);
/**
 * @param {string} path - path đã bỏ tiền tố ngôn ngữ
 * @param {string} language - ngôn ngữ của request
 * @returns {string|null} path tương đối (cùng ngôn ngữ) hoặc URL tuyệt đối (đổi ngôn ngữ), null nếu không cần chuyển
 */
export function resolveSitePageRedirect(path, language) {
  let decoded = path;
  try { decoded = decodeURIComponent(path); } catch (_) { /* Keep malformed escapes unmatched. */ }
  // Repair the old router link without accepting arbitrary redirect destinations.
  if (/^(?:\/[a-z0-9_-]+)*\/https?:\/{1,2}(?:en\.)?qrcode-gen\.com(?:\/en)?\/scan-qr-code\/?$/i.test(decoded)) return '/scan-qr-code';
  const lang = String(language || 'en').toLowerCase();
  const legal = legalPath(path);
  if (legal && (lang !== 'en' || path !== legal)) return englishUrl(legal);
  if (isPricingPath(path) && !['vi', 'en'].includes(lang)) return englishUrl('/service-pack');
  if (isPricingPath(path) && path !== '/service-pack') return '/service-pack';
  if (path === '/qrcode' || path === '/qrcode/') return '/';
  return null;
}
export function publicPageHref(path, language) {
  return resolveSitePageRedirect(path, language) || path;
}
export function pageIsNoIndex(path, language) {
  return isDocumentPath(path) && String(language).toLowerCase() !== 'en';
}
export function pageAlternateLanguages(path) {
  if (isDocumentPath(path)) return [];
  if (legalPath(path)) return ['en'];
  if (isPricingPath(path)) return ['en', 'vi'];
  return null;
}
